import CategoriesTable from './CategoriesTable'

export default CategoriesTable



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/MappingTabs/CategoriesTab/CategoriesTable/index.js